<template>
    <div>
        <div class="partner-saleCrusie partner-sailCruise-stateroom">
            <div class="container">
                <p class="partner-title">深度特惠航次</p>
                <div class="partner-crusieCon list-content-left" v-if="cruises.length>0" >
                    <PartnerCruiseItem 
                    v-for="(cruise) in cruises" :key="('cruise_'+ cruise.id)"
                    :cruise="cruise"
                    :rowCruiseSearchHandler="rowCruiseSearchHandler"
                    :showLoginPopup="showLoginPopup"
                    />
                </div>
                <div class="partner-crusieCon list-content-left" v-else>
                    <div class="noCouponCruise">
                        <span>暂无适用航次，敬请期待哦~</span><img src="https://resource.rcclchina.com.cn/partner/bookingSmile.png">
                    </div>
                </div>
            </div>
        </div>
        <div class="partner-saleCrusie">
            <div class="container">
                <p class="partner-title">九折航次推荐</p>
                <div class="partner-crusieCon list-content-left">

                    <PartnerHotCruiseItem 
                    v-for="(cruise) in hotCruises" :key="('hotCruise_'+ cruise.id)"
                    :cruise="cruise"
                    :rowCruiseSearchHandler="rowCruiseSearchHandler"
                    :showMoreSailDatePopup="showMoreSailDatePopup"
                    :showLoginPopup="showLoginPopup"
                    />

                    <div class="cruise-check-more">
                        <a @click="goCrusieSearch">查看更多精彩航线 &gt;</a>
                    </div>

                </div>
            </div>
        </div>
         <MoreSailDatePopup 
            :isShow="isShowMoreSailDatePopup"
            :cruise="targetCruise"
            :moreSailDatePopupClose="closeMoreSailDatePopup"
            :rowCruiseSearchHandler="rowCruiseSearchHandler"
            :showLoginPopup="showLoginPopup"
        />
    </div>
</template>

<script>
const PartnerCruiseItem = () => import('@/components/Partner/PartnerCruiseItem')
const PartnerHotCruiseItem = () => import('@/components/Partner/PartnerHotCruiseItem')
const MoreSailDatePopup = () => import('@/components/Cruise/MoreSailDatePopup.vue')
export default {
    name: "PartnerCruise",
    components: {
        PartnerCruiseItem,
        PartnerHotCruiseItem,
        MoreSailDatePopup
    },
    props: {
        cruises: {
            type: Array,
            default () {
                return []
            }
        },
        hotCruises: {
            type: Array,
            default () {
                return []
            }
        },
        rowCruiseSearchHandler: {
            type: Function
        },
        isRow: {
            type: Boolean,
            default() {
                return false
            }
        },
        showLoginPopup: {
            type: Function
        }
    },
    data () {
        return {
            isShowMoreSailDatePopup: false,
            targetCruise: {}
        }
    },
    methods: {
        showMoreSailDatePopup (cruise) {
            this.targetCruise = {
                cruiseName: cruise.cruiseName,
                shipCode: cruise.shipCode,
                sailDate: cruise.sailDate,
                isRow: cruise.isRow
            }
            this.isShowMoreSailDatePopup = true
        },
        closeMoreSailDatePopup () {
            this.targetCruise = {}
            this.isShowMoreSailDatePopup = false
        },
        goCrusieSearch () {
            if (this.isRow) {
                const url = `${process.env.VUE_APP_TUI_URL}/Cruise/Search`
                if (this.rowCruiseSearchHandler) {
                    this.rowCruiseSearchHandler(url)
                } else {
                    location.href = url
                }
            } else {
                this.$router.push({
                    name: "CruiseSearch"
                })
            }
        }
    }

}
</script>

<style lang="less" scoped>
.partner-saleCrusie {
    padding-top: 80px;
    .container {
        width: 1200px;
    }
    .partner-crusieCon {
        margin-top: 40px;
        .noCouponCruise {
            text-align: center;
            font-size: 16px;
            img {
                height: 20px;
            }
        }
    }
    .cruise-check-more {
        width: 320px;
        height: 50px;
        margin: 60px auto 0 auto;
        font-size: 22px;
        text-align: center;
        font-weight: 500;
        cursor: pointer;
        border: solid 2px #fbc500;
        line-height: 50px;
        border-radius: 24px;
        position: relative;
        a {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            color: inherit;
            background-color: transparent;
        }
    }
}
</style>